module.exports = __webpack_public_path__ + "static/media/38.cb8fe5c2.mp3";